<template>
  <div>
    <div v-if="!anfragen.length > 0">
      <div class="subheading" v-if="!zeigeversteckte">
        <v-icon left>info</v-icon> Aktuell keine Anfragen vorhanden.
      </div>
      <div class="subheading" v-else>
        <v-icon left>info</v-icon> Noch keine Anfragen versteckt.
      </div>
    </div>

    <v-list
      v-else
      three-line
      class="pa-0 ma-0"
    >
      <v-slide-x-reverse-transition
        class="py-0"
        group
        tag="v-list" 
      >

        <template v-for="item in anfragen">
          <v-list-tile
            :key="item.id"
            avatar
            :to="{name: 'anfragedetail', params: { id: item.hashid }}"
            ripple
          >
          <!--  <v-list-tile
            :key="item.id"
            avatar
            :to="{name: 'anfragedetail', params: { id: item.hashid }}"
            :color="item.bereitsgesehen[0] ? 'grey' : ''"
          > -->

            <v-list-tile-avatar>

              <v-icon v-if="item.landingbezug">groups</v-icon>
              <v-icon v-else>person</v-icon>
             
            </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>von <strong>{{ item.name }}</strong></v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                  <span v-if="item.landingbezug">
                    Anfrage im Themenbereich: <strong>{{ item.landingbezug.name }}</strong>
                  </span>
                  <span v-else>Direkte Anfrage: <strong>{{ BetriebsName }}</strong>
                  </span>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title class="text--primary">
                  
                  <span v-if="item.landingbezug">
                    {{ item.text | pretty }}
                  </span>
                  <span v-else>{{ item.text }}</span>
                
                </v-list-tile-sub-title>
              </v-list-tile-content>

               <v-list-tile-action>
                <v-list-tile-action-text class="text--primary">
                  <timeago :datetime="item.updated_at"></timeago>   
                </v-list-tile-action-text>
                 <anfrage-verstecken
                      :anfrage="item"
                      :key="item.id"
                      @anfragerefresh="versteckeanfrage(item)"
                    >
                    </anfrage-verstecken>
              </v-list-tile-action>


            <!--  <v-list-tile-content>
              <v-list-tile-title>
                {{ item }}
              </v-list-tile-title>	</v-list-tile-content> -->
              <!--  <v-list-tile-title v-if="item.landingbezug">
               Thema <strong>{{ item.landingbezug.name }}</strong>
                in <strong>{{ item.stadtbezug.name }}</strong> -->

                <!-- <v-icon
                  small
                  right
                  :color="item.bereitsgesehen[0] ? 'grey' : ''"
                >remove_red_eye</v-icon>
                <span class="caption">{{ item.userscount }}</span>
                <v-icon
                  small
                  right
                  :color="item.bereitsgesehen[0] ? 'grey' : ''"
                >mail_outline</v-icon>
                <span class="caption">{{ item.kontaktcount }}</span> 

              </v-list-tile-title>-->
              <!-- <v-list-tile-sub-title :color="item.bereitsgesehen[0] ? 'grey' : ''">
                <strong>
                  <timeago :datetime="item.updated_at"></timeago>
                </strong>

                <span
                  v-for="(value, key) in item.text"
                  :key="key"
                >
                  {{ key }}: {{ TrueTransform(value) }},
                </span>
              </v-list-tile-sub-title>
            </v-list-tile-content> -->
            <!-- <v-list-tile-action v-if="!zeigeversteckte">
              <anfrage-verstecken
                :anfrage="item"
                :key="item.id"
                @anfragerefresh="versteckeanfrage(item)"
              >
              </anfrage-verstecken>
            </v-list-tile-action> -->
          </v-list-tile>
          <v-divider
              :key="item.id + 'b'"
              inset
            ></v-divider>
        </template>
      </v-slide-x-reverse-transition>
    </v-list>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import AnfrageVerstecken from '~/components/anfragen/AnfrageVerstecken.vue'

export default {
  props: ['anfragen', 'zeigeversteckte'],
  components: {
    AnfrageVerstecken
  },

  data () {
    return {
     // loading: true
    }
  },
  computed: {
    BetriebsName: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.Vollername) {
          return this.$store.getters.authBetrieb.Vollername
        }
      } else {
        return 'Name'
      }
    }
  },
  mounted: function () {},
  methods: {
    TrueTransform: function (value) {
      if (value === true) {
        return 'gewünscht'
      } else {
        return value
      }
    },
    versteckeanfrage: function (item) {
      // console.log(item)
      this.$emit('anfrageversteckt', item)
    }
  },
  filters: {
    pretty: function (value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    }
  }
}
</script>

<style>
</style>